// This is the way the app shoud be polyfilled now that core-js3 replace
// babel.
// Why the fuck this can't be done in the config? All the tutorials give
// wrong solutions for now except this crappy one.
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import VueI18n from 'vue-i18n'

import App from './App.vue'
import router from './components/router'
import messages from './i18n'
import store from './components/store'
import WS from './components/ws'

Vue.config.productionTip = false

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'fr', // set locale
  fallbackLocale: 'en',
  messages // set locale messages
})

function init () {
  import(`@/custom/${process.env.VUE_APP_CUSTOM}/settings`).then((module) => {
    const settings = module.default()
    Vue.prototype.$settings = settings
    Vue.prototype.$socket = WS(store, settings, router)

    // Sentry.init({ dsn: settings.sentry});

    new Vue({
      i18n,
      router,
      store,
      render: h => h(App),
      beforeMount () {
        // Sentry.captureException(new Error("This is my fake error message"));

        const token = localStorage.token ? localStorage.token : ''
        const allowedRoutes = ['/login', '/change-password', '/password-reset']
        let startPathName = window.location.pathname
        if (window.location.pathname.lastIndexOf('/') > 0) {
          startPathName = startPathName.substring(
            0, window.location.pathname.indexOf('/', 1))
        }
        if (token === '' && allowedRoutes.indexOf(startPathName) === -1) {
          window.location.href = '/login'
        }
        this.$socket.init()
      }
    }).$mount('#app')
  })
}

init()
